import React from "react";
import { useIntl } from "react-intl";
import { Row, Col, Typography } from "antd";

const { Paragraph, Title, Text } = Typography;

const AddressImportInstructions = () => {
  const intl = useIntl();
  return (
    <Row>
      <Col>
        <Title level={3}>
          {intl.formatMessage({
            id: "address.import.dataFormat",
            defaultMessage: "Popis datového formátu zákazníka",
          })}
        </Title>
        <Paragraph>
          <Text>
            {intl.formatMessage({
              id: "address.import.info",
              defaultMessage:
                "Pro všechny atributy platí stejné omezení jako při vytváření zásilky pomocí webového formuláře. Atributy nejsou až na výjimky povinné.",
            })}
          </Text>
        </Paragraph>
        <ol>
          <li>
            {intl.formatMessage({
              id: "address.import.name",
              defaultMessage: "název zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.subname",
              defaultMessage: "sekundární název zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.street",
              defaultMessage: "název ulice zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.streetNumber",
              defaultMessage: "číslo popisné/orientační zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.localDestination",
              defaultMessage: "místní určení (upřesnění adresy) zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.city",
              defaultMessage: "město zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.zipCode",
              defaultMessage:
                "PSČ zákazníka; formát dle vybraného státu zákazníka (vnitřní mezery budou smazány)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.country",
              defaultMessage:
                "stát zákazníka; ve dvoumístném (ISO 3166-1 Alpha-2) nebo třímístném formátu (ISO 3166-1 Alpha-3)",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.contactPerson",
              defaultMessage: "kontaktní osoba zákazníka",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.contactPhone",
              defaultMessage:
                "telefonní kontakt na zákazníka; validní formát dle daného předčíslí, v případě, že není předčíslí zadané, je doplněno české (+420); předčíslí je možné zadat ve formátu +XX nebo 00XX nebo XX",
            })}
          </li>
          <li>
            {intl.formatMessage({
              id: "address.import.contactEmail",
              defaultMessage:
                "emailový kontakt na zákazníka; požadován validní formát emailu",
            })}
          </li>
        </ol>
      </Col>
    </Row>
  );
};

export default AddressImportInstructions;
